import styled from 'styled-components';

export const UiOrganizationSessionFormPage = styled.div`
`;